import React, { Component } from 'react';
import _ from 'lodash';

import PhotoUserItem from './userPaygoInfoProfile/profile-user-photo.jsx';

import 'react-infinite-calendar/styles.css'; // Make sure to import the default stylesheet

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getReports, getClientMessages } from '../../../../../jsx/actions/reportAction';
import { getPaygClients, getClientRecoveryActions, getPaygDashboardInfo, getPaygResumeInfo } from '../../../../../jsx/actions/clientAction';
import { fetchSubscriptions } from '../../../../../jsx/actions/subscriptionAction';
import { getClientInfoList } from '../../../../../jsx/actions/devisAction';
import { getPayments } from '../../../../../jsx/actions/paymentAction';

import Stats from './PaygPopUp/Stats.jsx';
import ClientInfo from './PaygPopUp/ClientInfo.jsx';
import Installs from './PaygPopUp/Installs.jsx';
import Payments from './PaygPopUp/Payments.jsx';
import ClientReports from './PaygPopUp/ClientReports.jsx';
import SuiviRecovery from './PaygPopUp/SuiviRecovery.jsx';
import SuiviReports from './PaygPopUp/SuiviReports.jsx';
import SuiviHome from './PaygPopUp/SuiviHome.jsx';
import SuiviDevis from './PaygPopUp/SuiviDevis.jsx';
import { isEmpty } from 'lodash';
import SuiviGeneral from './PaygPopUp/SuiviGeneral.jsx';
import PopUp from '../../commonModules/interface/PopUp.jsx';
import { Box, Button, Tabs, Tab } from '@material-ui/core';
import { a11yProps } from '../../commonModules/MUI/SwipeableTabs';

class Photo extends Component {
    render (){
        const { boxAssoId } = this.props
        return (
            <div>
                <PhotoUserItem boxAssoId={boxAssoId} />
            </div>
                                
        )
    }
}

class PaygPopupInfo extends React.PureComponent {
    state = {
        messagesIdList: [],
        headerMenu: this.props.default_tab || "DASHBOARD",
        file:"",
    }
    
    sortByDate = (list) => {
        // Copie avant tri : les appelants passent des tableaux du store Redux
        // (clients[id].reports…), sort() en place déclencherait l'invariant
        // "state mutation inside a dispatch".
        return [...list].sort((a, b) => {
            return new Date(a) - new Date(b)
        });
    }
     
    componentDidMount = async () => {
        const { SUBSCRIPTIONS, CLIENTS, boxAssoId, STATE } = this.props;
        if(!STATE.paygClients.fetching && !STATE.paygClients.fetched){
			await this.props.getClients()
		}
        if (!SUBSCRIPTIONS){
            this.props.fetchSubscriptions()         
        }
        if(!this.props.STATE.payments.fetching && !this.props.STATE.payments.fetched){
			this.props.getPayments()
		}

        this.props.QUOTATION_INFO_LIST && this.props.getInfos(this.props.boxAssoId) 

        const client = CLIENTS[boxAssoId]
        // console.log('====================================');
        // console.log({client, CLIENTS});
        // console.log('====================================');

        if (client && !client.dashboard_info) {
            this.props.getPaygDashboardInfo([boxAssoId])
        }
        if (client && !client.resume_info){
            this.props.getPaygResumeInfo([boxAssoId])
        }
    }

    getTabLabel = ( tab ) => {
        this.setState({ headerMenu: tab })
    }
    getLabelsList = () => {
        let labels = []

        if (!this.props.NO_DASHBOARD){
            labels.push("DASHBOARD")
        }
        if (this.props.USER_INFO_LIST){
            labels.push("INFO")
        }
        if (this.props.BOX_INFO_LIST){
            labels.push("INSTALLATION")
        }

        if (this.props.PAYMENTS_INFO_LIST){
            labels.push("REMBOURSEMENT")
        }

        if (this.props.SUIVI_INFO_LIST){
            labels.push("SUIVI")
        }

        if (this.props.SUIVI_RECOVERY){
            labels.push("RECOUVREMENT")
        }
        if (this.props.PHOTO){
            labels.push("PHOTOS")
        }

        if (this.props.REPORTS){
            labels.push("MAINTENANCE")
        }

        if (this.props.QUOTATION_INFO_LIST){
            labels.push("SUIVI DEVIS")
        }
            
        return labels

    }
    render() {
        // console.log('PAYG POP UP INFO in PopupInfo : ', this.props);
        const { CLIENTS, boxAssoId, PAYMENTS, REPORTS, SUBSCRIPTIONS, PROSPECTS, prospect } = this.props
        const { headerMenu } = this.state;
        const clientInfo = CLIENTS[boxAssoId]
        let title = (clientInfo && clientInfo.resume) ? `Box ${clientInfo.resume.idBox} - ${clientInfo.resume.clientName}` : "";
        let labels = this.getLabelsList()
        // console.log({labels, clientInfo, boxAssoId, PROSPECTS} )

        // cdm ?
        let client_resume_info = {}
        let client_payments_list =  []
        let client_payments_map = {}
        let client_reports_list = []
        let client_recovery_list = null
        let userID = this.props.userID
        let client_abo = {}

        if(clientInfo) {
            client_resume_info = clientInfo.resume
            // client_payments_list = clientInfo.payments ? this.sortByDate(clientInfo.payments) : []
            // Copie avant reverse : l'original appartient au store Redux (clients[id].payments),
            // le muter pendant le render déclenche l'invariant "state mutation inside a dispatch".
            client_payments_list = clientInfo.payments ? [...clientInfo.payments].reverse() : []
            client_reports_list = clientInfo.reports ? this.sortByDate(clientInfo.reports) : []
            // Ne transmettre que les paiements du client courant, pas tout le store
            // global state.payments (des dizaines de milliers d'entrées depuis le
            // deblocage du chargement des paiements). Les sous-composants lisent
            // PAYMENTS[ID] uniquement via paymentsIDList, donc une map restreinte
            // suffit et evite de serialiser/re-render un objet enorme a chaque frappe.
            client_payments_map = {}
            client_payments_list.forEach(ID => {
                if (PAYMENTS && PAYMENTS[ID]) client_payments_map[ID] = PAYMENTS[ID]
            })
            client_recovery_list = clientInfo.recovery || null
            userID = client_resume_info.userID
            client_abo = !isEmpty(SUBSCRIPTIONS) && SUBSCRIPTIONS[client_resume_info.subscriptionID]
        } else if(prospect && this.props.clientInfo) {
            client_resume_info = this.props.clientInfo
            title = `${client_resume_info.Nom} ${client_resume_info.Prénom && client_resume_info.Prénom} - ${boxAssoId}`
        }
        // if(!prospect && clientInfo) {
        //     client_resume_info = clientInfo.resume
        //     client_payments_list = clientInfo.payments ? this.sortByDate(clientInfo.payments) : []
        //     client_reports_list = clientInfo.reports ? this.sortByDate(clientInfo.reports) : []
        //     client_recovery_list = clientInfo.recovery || null
        //     userID = client_resume_info.userID
        //     client_abo = !isEmpty(SUBSCRIPTIONS) && SUBSCRIPTIONS[client_resume_info.subscriptionID]
        // } else if (prospect){
        //     client_resume_info = PROSPECTS.RESUME[boxAssoId]
        //     client_abo = ""
        //     console.log('================= IS PROSPECT===================');
        //     console.log({client_resume_info});
        //     console.log('====================================');
        //     title = `${client_resume_info.Nom} ${client_resume_info.Prénom} - ${boxAssoId}`
        //     console.log('================= IS PROSPECT===================');
        //     console.log({client_resume_info, title});
        //     console.log('====================================');
        // }
        return (
            <PopUp
                close={this.props.closePopup}
                title={title}
                scroll="paper"
                appbar
                fullScreen
            >
                {/* <SwipeableTabs
                    default={this.state.headerMenu}
                    labels={labels}
                    getLabel={this.getLabel}
                > */}
                {/* </SwipeableTabs> */}

                <Tabs
					value={headerMenu}
					onChange={(e, headerMenu) => this.setState({ headerMenu })}
					indicatorColor="primary"
					// textColor="primary"
					scrollButtons="auto"
					variant="fullWidth"
					// variant="scrollable"
				>
					{labels.map( (label, i) => (
						<Tab label={label} {...a11yProps(i)} key={label} value={label} />
					))}
				</Tabs>
                <Box p={1}>
                    {headerMenu === "DASHBOARD" &&
                        <Stats 
                            userInfo={client_resume_info} 
                            paymentsIDList={client_payments_list}
                            reportsIDList={client_reports_list}
                            PAYMENTS={client_payments_map}
                            REPORTS={REPORTS}
                            abo={client_abo}
                            boxAssoId={boxAssoId}
                        />
                    }
                    { headerMenu === "INFO" &&
                        <ClientInfo 
                            profile_list={this.props.USER_INFO_LIST} 
                            userInfo={client_resume_info} 
                            boxAssoId={boxAssoId} 
                        />
                    }
                    { headerMenu === "INSTALLATION" &&
                        <Installs 
                            profile_list={this.props.BOX_INFO_LIST} 
                            boxAssoId={boxAssoId} 
                        />
                    }
                    { headerMenu === "REMBOURSEMENT" &&
                        <Payments 
                            profile_list={this.props.PAYMENTS_INFO_LIST} 
                            boxAssoId={boxAssoId}  
                            userInfo={client_resume_info} 
                        />
                    }
                    { headerMenu === "SUIVI" &&
                    <Box>
                        {this.props.recovery &&
                            <SuiviRecovery 
                                userInfo={client_resume_info} 
                                boxAssoId={boxAssoId} 
                                paymentsIDList={client_payments_list} 
                                PAYMENTS={client_payments_map}
                                recoveryIDList = {client_recovery_list}
                                getClientRecoveryActions = {this.props.getClientRecoveryActions}
                                abo={client_abo}
                            />
                        } 
                        {this.props.reports &&
                            <Box>
                                <Box>
                                    <Button onClick={this.props.edit} color="secondary">
                                        Editer
                                    </Button>
                                </Box>
                                <SuiviReports
                                    comments={this.props.comments}
                                    audios={this.props.audios}
                                />
                            </Box>                            
                        } 
                        { this.props.home &&
                            <SuiviGeneral 
                                abo={client_abo}
                                userInfo={client_resume_info}
                                boxAssoId={boxAssoId}  
                                paymentsIDList={client_payments_list} 
                                PAYMENTS={client_payments_map}
                                recoveryIDList = {client_recovery_list}
                                getClientRecoveryActions = {this.props.getClientRecoveryActions}
                            />
                        }                  
                    </Box>
                    }
                    { headerMenu === "RECOUVREMENT" &&
                        <SuiviRecovery 
                            userInfo={client_resume_info} 
                            boxAssoId={boxAssoId} 
                            paymentsIDList={client_payments_list} 
                            PAYMENTS={client_payments_map}
                            recoveryIDList = {client_recovery_list}
                            getClientRecoveryActions = {this.props.getClientRecoveryActions}
                            abo={client_abo}
                        />  
                    }
                    { headerMenu === "PHOTOS" &&
                        <Photo 
                            boxAssoId={boxAssoId} 
                            userInfo={client_resume_info}
                        />
                    }
                    { headerMenu === "MAINTENANCE" &&
                        <ClientReports 
                            boxAssoId={boxAssoId} 
                        />
                    }
                    { headerMenu === "SUIVI DEVIS" &&
                        <SuiviDevis 
                            boxAssoId={boxAssoId} 
                        />
                    }
                </Box>
            </PopUp>
            
        );
    }
}


function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        REPORTS: state.reports,
        PAYMENTS: state.payments,
        CLIENTS: state.clients,
        STATE: state.inventory.requestState,
        PROSPECTS: state.prospects,
        SUBSCRIPTIONS: state.subscriptions,
        state: state.inventory.requestState.reports
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        getReports,
        getClients: getPaygClients,
        getClientMessages,
        getClientRecoveryActions,
        fetchSubscriptions,
        getInfos: getClientInfoList,
        getPaygDashboardInfo,
        getPaygResumeInfo,
        getPayments,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PaygPopupInfo);
